import styled from 'styled-components'

import typeStyle from 'styles/typeStyle'

export const SpinnerWrapper = styled.div`
  ${typeStyle('-ds-font-body-regular')}
  padding: 16px;

  em {
    color: #999;
  }
`

export const AutocompleteDropdownResult = styled.div`
  ${typeStyle('-ds-font-body-regular')}
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
  padding: 8px;
  width: 100%;
  text-transform: none;
  background-color: ${({ theme }) => theme?.['-ds-neutral-100']?.value};
  transition: background-color 0.3s;
  border-radius: 4px;

  &:hover,
  &:focus {
    background-color: ${({ theme }) => theme?.['-ds-neutral-300']?.value};
    cursor: pointer;
  }
`

export const DropDownWrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  color: ${({ theme }) => theme?.['-ds-neutral-600']?.value};
`

export const DropdownTitle = styled.p`
  ${typeStyle('-ds-font-body-regular')}
  margin: 4px 0;
  color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
  line-height: 1.2;
`
